import React from 'react';
import './StatsSection.css';

const StatsSection = () => {
  const stats = [
    {
      number: '8+',
      label: 'Years in Industry',
      sub: 'First office in Hyderabad'
    },
    {
      number: '400+',
      label: 'Student Engagements',
      sub: 'Completed since 2016'
    },
    {
      number: '40,000+',
      label: 'Hours of Lessons Imparted',
      sub: ''
    },
    {
      number: 'XX+',
      label: 'Students with Successful Careers',
      sub: ''
    }
  ];

  return (
    <section className="stats-section">
      <div className="stats-container">
        {stats.map((stat, index) => (
          <div className="stat-item" key={index}>
            <div className="stat-number">{stat.number}</div>
            <div className="stat-label">{stat.label}</div>
            {stat.sub && <div className="stat-sub">{stat.sub}</div>}
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsSection;